import { Wallet } from "lucide-react";
import type { FC } from "react";
import { IconProps } from "./types";

export const Payment: FC<IconProps> = ({ size = "1em", ...props }) => (
  <Wallet width={size} height={size} {...props} />
);
